import WaiterLogin from '../../components/scenes/WaiterLogin'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
// import * as basketActions from '../../actions/components/basket'
import * as userActions from '../../actions/components/user'
import * as merchantActions from '../../actions/components/merchant'
import { bindActionCreators } from 'redux'

const mapStateToProps = (state) => {
  return {
    // merchant: state.merchant,
    // user: state.user,
    // basket: state.basket,
    // discount: state.basket.discount,
  }
}
const mapDispatchToProps = (dispatch) => {
  // const { getRecentPaymentInfo, updatePromoCode } = bindActionCreators(basketActions, dispatch)
  // const { loginWaiter } = bindActionCreators(userActions, dispatch)
  return {
    ...bindActionCreators(userActions, dispatch),
    ...bindActionCreators(merchantActions, dispatch),
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(WaiterLogin)))



// WEBPACK FOOTER //
// ./src/containers/scenes/WaiterLogin.js